<template>
  <lb-drawer
    :value="open"
    :heading="drawerHeading"
    width="700"
    :loading="loading"
    data-testid="setup-tasklist__custom-field-dialog"
    @input="onInput"
  >
    <template v-slot:body>
      <v-row>
        <v-col cols="6" class="my-0 py-0">
          <p class="mb-1 gray--text">Cycle Type</p>
          <lb-dropdown
            v-model="localForm.cycleType"
            label="Select Cycle type"
            :items="cycleTypes"
            itemtext="displayText"
            itemvalue="name"
            item-class="noTransform"
            :error="errors.cycleType"
            :disabled="mode === 'edit'"
            data-testid="setup-tasklist__custom-field-cycle-type"
          />
        </v-col>

        <v-col cols="6" class="my-0 py-0">
          <p class="mb-1 gray--text">Field Name</p>
          <lb-string
            v-model="localForm.displayName"
            label=""
            placeholder="Enter display name"
            :error="errors.displayName"
            data-testid="setup-tasklist__custom-field-display-name"
          />
        </v-col>

        <v-col cols="6" class="my-0 py-0">
          <p class="mb-1 gray--text">Data Type</p>
          <lb-dropdown
            v-model="localForm.dataType"
            :items="columnDataTypes"
            label=""
            placeholder="Select data type"
            :error="errors.dataType"
            itemtext="displayText"
            itemvalue="name"
            item-class="noTransform"
            :disabled="mode === 'edit'"
            data-testid="setup-tasklist__custom-field-data-type"
          />
        </v-col>
      </v-row>
    </template>

    <template v-slot:actions>
      <v-spacer />
      <v-btn text data-testid="setup-tasklist__custom-field-cancel" @click="onCancel">
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        class="white--text"
        :loading="loading"
        data-testid="setup-tasklist__custom-field-save"
        @click="onSave"
      >
        {{ mode === 'edit' ? 'Update' : 'Create' }}
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
import { COLUMN_DATA_TYPES, CYCLE_TYPES } from '../../utils/taskListConstants';
import { columnNameFromDisplayName } from '../../utils/taskListPayload';
import { validateCustomFieldForm } from '../../utils/taskListHelpers';

export default {
  name: 'CustomFieldDialog',

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'add',
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    existingColumns: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localForm: this.defaultForm(),
      errors: {},
    };
  },

  computed: {
    drawerHeading() {
      return this.mode === 'edit' ? 'Edit Custom Field' : 'Add Custom Field';
    },
    columnDataTypes() {
      return COLUMN_DATA_TYPES;
    },
    cycleTypes() {
      return CYCLE_TYPES.map((c) => ({ name: c.id, displayText: c.label }));
    },
  },

  watch: {
    open(val) {
      if (val) this.hydrateForm();
    },
    form: {
      deep: true,
      handler() {
        if (this.open) this.hydrateForm();
      },
    },
  },

  methods: {
    defaultForm() {
      return {
        _id: null,
        cycleType: 'FBC',
        displayName: '',
        dataType: '',
        columnName: '',
      };
    },

    hydrateForm() {
      this.localForm = {
        ...this.defaultForm(),
        ...this.form,
        cycleType: (this.form.cycleType || this.form.cycle_type || 'FBC').toUpperCase(),
      };
      this.errors = {};
    },

    onInput(val) {
      if (!val) this.onCancel();
    },

    onCancel() {
      this.errors = {};
      this.$emit('cancel');
    },

    onSave() {
      this.errors = validateCustomFieldForm(this.localForm, this.existingColumns);
      if (Object.values(this.errors).some(Boolean)) {
        this.$store.commit('sbError', 'Please fill all the required fields');
        return;
      }

      const columnDetails = {
        ...this.localForm,
        columnName: columnNameFromDisplayName(this.localForm.displayName),
        cycleType: this.localForm.cycleType.toUpperCase(),
      };

      this.$emit('save', columnDetails);
    },
  },
};
</script>
